import { render, staticRenderFns } from "./player.profile.vue?vue&type=template&id=3bc5c6b5&scoped=true&"
import script from "./player.profile.vue?vue&type=script&lang=js&"
export * from "./player.profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5c6b5",
  null
  
)

export default component.exports